import { ApiRequestError } from './api';

/**
 * AZ UTOLSO ISMERT ALLAPOT kapcsolat nelkuli indulashoz (K2, 4. csomag).
 *
 * Az offline app-vaz (sw.js) elinditja az alkalmazast terero nelkul is -
 * de a bejelentkezett felhasznalo es a csatornalista nelkul az csak egy
 * "Betoltes…" felirat lett volna. Ezt a kettot ezert az eszkozon is
 * megjegyezzuk, es CSAK akkor adjuk vissza, ha a szerver nem erheto el
 * (halozati vagy 5xx hiba). 401-nel soha: a lejart belepest nem fedjuk el.
 *
 * Kijelentkezeskor torlodik (`forgetOfflineCache`).
 */
const PREFIX = 'avslack:offline:';

/** Melyik adatot adtuk vissza az eszkozrol (a szerver helyett) - lasd `takeServedFromCache`. */
const servedFromCache = new Set<string>();

/**
 * A tarolt peldanyrol kiszolgalt adatok neve - es a lista uritese.
 *
 * Amint ujra van kapcsolat, ezeket ujra kell kerni: kulonben a telefon a
 * kapcsolat nelkuli indulaskori allapotot mutatna, amig valami magatol nem
 * frissiti (data/outbox.ts).
 */
export function takeServedFromCache(): string[] {
  const names = [...servedFromCache];
  servedFromCache.clear();
  return names;
}

function unreachable(error: unknown): boolean {
  return !(error instanceof ApiRequestError) || error.status >= 500;
}

/** A `name` a lekeres kulcsanak elso eleme (pl. `['channels']` -> `'channels'`). */
export function withOfflineFallback<T>(name: string, fetcher: () => Promise<T>): () => Promise<T> {
  return async () => {
    try {
      const value = await fetcher();
      try {
        localStorage.setItem(PREFIX + name, JSON.stringify(value));
      } catch {
        // tele a tarhely vagy privat mod - attol meg mukodik
      }
      return value;
    } catch (error) {
      if (error instanceof ApiRequestError && error.status === 401) forgetOfflineCache();
      if (unreachable(error)) {
        try {
          const cached = localStorage.getItem(PREFIX + name);
          if (cached) {
            servedFromCache.add(name);
            return JSON.parse(cached) as T;
          }
        } catch {
          // serult bejegyzes - mintha nem lenne
        }
      }
      throw error;
    }
  };
}

export function forgetOfflineCache(): void {
  try {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith(PREFIX)) localStorage.removeItem(key);
    }
  } catch {
    // nincs mit torolni
  }
}

/**
 * Egy csatorna fajtaja az eszkozon tartott listabol - akkor is, ha az adott
 * ablak (pl. a hivas kulon ablaka) maga nem toltotte be a csatornakat.
 */
export function cachedChannelKind(channelId: string): string | null {
  try {
    const raw = localStorage.getItem(PREFIX + 'channels');
    if (!raw) return null;
    const list = JSON.parse(raw) as { id: string; kind: string }[];
    return list.find((channel) => channel.id === channelId)?.kind ?? null;
  } catch {
    return null;
  }
}
